package devxertech.com.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px

@Composable
fun LinkText(path: String = "", text: String){
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()
    FieldTitleTextNormalSimple(
        text,
        color = sitePalette.textFieldBorderColor.rgb,
        fontFamily = Constants.FONT_FAMILY,
        fontSize = 13.px,
        onClick = {ctx.router.navigateTo(path)},
        isClickable = true,
        marginTop = 10.px,
        marginBottom = 10.px
    )
}
fun openLinkInNewTab(url: String) {
    window.open(url, "_blank")
}